import { Box } from '@mui/material';
import { styled } from '@mui/styles';

export const Container = styled((props) => (
  <Box {...props} />
))({
  margin: '1rem 3rem 1rem 3.75rem',
});
